import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b9ddf2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-right"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("設定")
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading mb20" }, "デイリートレーニング", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("今日のラーニングを受ける")
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt20" }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 履歴確認")

import { computed } from "vue";
import { DailyLearningAnswer } from "@/types/DailyLearningAnswer";
import { DailyLearning } from "@/types/DailyLearning";
import { useStore } from "vuex";
interface Props {
  project_id: number;
  daily_learning_answers: DailyLearningAnswer[];
  daily_learning: DailyLearning | null;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    project_id: { type: Number, required: true },
    daily_learning_answers: { type: Array, required: true },
    daily_learning: { type: null, required: true }
  },
  setup(__props: any) {

const props = __props as {
  project_id: number;
  daily_learning_answers: DailyLearningAnswer[];
  daily_learning: DailyLearning | null;
}
const store = useStore();
const managerFlg = computed(() => store.state.login.manager_flg || store.state.login.project_owner_flg);




return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(managerFlg))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_router_link, {
            to: { name: 'ProjectDailySetting', params: { project_id: _ctx.$route.params.project_id } },
            class: "button-link"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, null, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]))
      : _createCommentVNode("", true),
    (__props.daily_learning != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          (__props.daily_learning.status == 'todo')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: { name: 'ProjectLearningCourse', params: { project_id: _ctx.$route.params.project_id, learning_course_id: __props.daily_learning.learning_course_id } },
                  class: "button-link"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      round: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : (__props.daily_learning.status == 'finish')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, "今日のラーニングは受験済みです"))
              : (__props.daily_learning.status == 'not_create')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, "今日のラーニングはありません"))
                : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _hoisted_9,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.daily_learning_answers, (daily_learning_answer) => {
      return (_openBlock(), _createElementBlock("div", {
        key: daily_learning_answer.learning_course_id,
        class: "fs14"
      }, [
        _createTextVNode(_toDisplayString(daily_learning_answer.name) + " 解答数：" + _toDisplayString(daily_learning_answer.answer_count) + " 正解数：" + _toDisplayString(daily_learning_answer.correct_count) + " 問題数：" + _toDisplayString(daily_learning_answer.learning_count) + " ", 1),
        _createVNode(_component_router_link, {
          to: { name: 'ProjectLearningCourseHistory', params: { project_id: _ctx.$route.params.project_id, learning_course_id: daily_learning_answer.learning_course_id } }
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 2
        }, 1032, ["to"])
      ]))
    }), 128))
  ], 64))
}
}

})